var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHourglassSimple = function SvgIconHourglassSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.56 2.75h-.002a1.75 1.75 0 0 0-1.229 2.994L10.586 12l-6.257 6.256a1.75 1.75 0 0 0 1.229 2.994h12.884a1.75 1.75 0 0 0 1.229-2.994L13.414 12l6.257-6.256a1.75 1.75 0 0 0-1.229-2.994zM12 10.586 6.164 4.75h11.672zm0 2.828 5.836 5.836H6.164z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHourglassSimple;